import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getInfoRequest } from 'ducks/users';

class Crisp extends Component {
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.user && this.props.user) {
      this.props.getInfoRequest({ user: this.props.user });
    }

    if (this.props.getInfoSuccess) {
      this.syncUserDataToCrisp();
    }
  }

  componentDidMount() {
    if (this.props.user) {
      this.props.getInfoRequest({ user: this.props.user });
    }
  }

  syncUserDataToCrisp = () => {
    if (window.$crisp) {
      try {
        window.$crisp.push(['set', 'user:email', this.props.email]);
        window.$crisp.push([
          'set',
          'session:data',
          [
            [
              ['user_id', this.props.user || ''],
              ['name', this.props.name || ''],
              ['signup_date', this.props.createdAt || ''],
              ['total_spending', this.props.totalSpending || 0],
              ['total_shipment', this.props.totalShipment || 0],
              ['last_waybill', this.props.lastWaybill || ''],
              ['last_waybill_date', this.props.lastWaybillDate || ''],
              ['incharge_sales', this.props.incharge_sales || ''],
              ['user_type', this.props.user_type || '']
            ]
          ]
        ]);
        window.$crisp.push(['set', 'user:phone', this.props.phone]);
      } catch (error) {
        console.log('Crisp Error: ', error);
      }
    } else {
      setTimeout(this.syncUserDataToCrisp, 500);
    }
  };

  render() {
    return <div></div>;
  }
}

const mapStateToProps = state => {
  const info = state.users.info || {};

  return {
    user: state.auth.user || false,
    email: state.auth.email || '',
    name: state.auth.name || '',
    phone: state.auth.phone || info.phone || '',
    createdAt: info.createdAt,
    totalSpending: info.totalSpending,
    totalShipment: info.totalShipment,
    lastWaybill: info.lastWaybill || null,
    lastWaybillDate: info.lastWaybillDate || null,
    incharge_sales: info.inchargeSales || null,
    user_type: info.userType || null,
    getInfoSuccess: state.users.getInfoSuccess || false
  };
};

const mapDispatchToProps = {
  getInfoRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(Crisp);
